import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import '../Assets/Styles/characters.css';
import ReactTransitionGroup from 'react-transition-group/TransitionGroup';
import classNames from 'classnames'

import {TimelineLite} from 'gsap'

import Character from './Character'

class CharactersContainer extends Component {

	constructor() {
    super();
    this.handleResize = this.handleResize.bind(this)
    this.showTickets = this.showTickets.bind(this)

    this.state = {
    	characterIndex: 0,
    	topAlign: false,
      showTickets: false,
      characters: [
	      {
	      	'id': 'starlord',
	      	'name': require('../Assets/Images/Characters/starlord-name.png'),
	      	'actor': 'chris pratt',
	      	'image': require('../Assets/Images/Characters/starlord.png'),
	      	'bio': 'The interstellar adventurer known as Peter Quill never imagined he’d one day be known far and wide as Star-Lord. But that’s exactly what happened after he and his unlikely team of misfits, the Guardians of the Galaxy, banded together to save the galaxy. Now, with a new outlook on his place in the universe, a mixtape of fresh tunes and a mystery from the past yet to be solved, Quill sets out with his friends to do something good, something bad – maybe even a bit of both.'
	      },
	      {
	      	'id': 'drax',
	      	'name': require('../Assets/Images/Characters/drax-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/drax.png'),
	      	'bio': 'Drax is a headstrong warrior whose reputation is both feared and respected throughout the sector. Despite his formidable outward appearance, the fierce fighter\'s lust for battle conceals a compassionate heart. Though once scarred by the loss of his family, the peculiar Drax has found a new home with his equally eccentric allies in The Guardians of the Galaxy.'
	      },
	      {
	      	'id': 'gamora',
	      	'name': require('../Assets/Images/Characters/gamora-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/gamora.png'),
	      	'bio': 'A daughter of the evil Thanos, Gamora sought to escape her violent past and build a new life free from her prior sins. When an unlikely twist of fate caused her to join The Guardians, the one-time most dangerous woman in the galaxy found her skills put to a better use saving countless lives.'
	      },
	      {
	      	'id': 'groot',
	      	'name': require('../Assets/Images/Characters/groot-name.png'),
	      	'actor': 'Vin Diesel',
	      	'image': require('../Assets/Images/Characters/groot.png'),
	      	'bio': 'After his heroic sacrifice during the culmination of The Guardians\' first adventure, the tree-like being known only as Groot is now in the process of regrowing his body from a single twig. Though once a towering giant, Groot\'s current, more diminutive form is more akin to a sapling than a redwood. Still, he remains an important, if now more mischievous, member of the eclectic Guardians.'
	      },
	      {
	      	'id': 'rocket',
	      	'name': require('../Assets/Images/Characters/rocket-name.png'),
	      	'actor': 'Bradley Cooper',
	      	'image': require('../Assets/Images/Characters/rocket.png'),
	      	'bio': 'A unique genetic creation, the tough-talking Rocket may resemble a certain Earth rodent, but you\'d be hard-pressed to find his like anywhere else in the galaxy. Rocket\'s abrasive attitude still sometimes causes friction with his teammates, though his unparalleled genius in mechanics and engineering usually make up for any disagreeable tendencies.'
	      },
	      {
	      	'id': 'yondu',
	      	'name': require('../Assets/Images/Characters/yondu-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/yondu.png'),
	      	'bio': 'Leader of the Ravagers, Yondu Udonta is an unscrupulous pirate perpetually in search of his next big score. Though once hired to capture the young earthling Peter Quill, a last-minute change of heart caused Yondu to betray his employer and bring Quill into the Ravager fold as one of his own, serving as his surrogate father. Though his greed often tempts him to betray even his closest allies, he does occasionally show a soft spot for Quill'
	      },
	      {
	      	'id': 'nebula',
	      	'name': require('../Assets/Images/Characters/nebula-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/nebula.png'),
	      	'bio': 'The second adopted daughter of the cosmic tyrant Thanos, Nebula was genetically modified with cybernetics to achieve victory by any means necessary. Since her defeat at the hands of the Guardians, Nebula comes hurtling back into the life of her sister Gamora hoping to finally settle their unfinished business. Now, Nebula will somewhat reluctantly fight alongside the Guardians of the Galaxy whilst she contemplates her own capacity for forgiveness.'
	      },
	      {
	      	'id': 'mantis',
	      	'name': require('../Assets/Images/Characters/mantis-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/mantis.png'),
	      	'bio': 'A strange alien who serves Ego, Mantis slowly ingratiates herself with the guardians with the help of her empathic powers. These abilities allow her to read the underlying emotions at play within the group which make for some embarrassing, hilarious, and touching moments. Mantis forms a special bond with Drax, who teaches her about the universe and the meaning of family from his own unique perspective. Mantis becomes a lynchpin team member who proves crucial to the Guardians over the course of their adventure.'
	      },
	      {
	      	'id': 'ego',
	      	'name': require('../Assets/Images/Characters/ego-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/ego.png'),
	      	'bio': 'After decades apart, an unlikely twist of fate has reunited Peter Quill with his estranged father, Ego. Little is known of the enigmatic man other than that he is a Cosmic traveler with mysterious Celestial powers. what revelations does his arrival foretell, and what will it mean for the Guardians of the Galaxy?'
	      },
	      {
	      	'id': 'ayesha',
	      	'name': require('../Assets/Images/Characters/ayesha-name.png'),
	      	'actor': 'Dave Bautista',
	      	'image': require('../Assets/Images/Characters/ayesha.png'),
	      	'bio': 'Ayesha is the exalted leader of the technologically advanced race of golden beings known as Sovereign. Though seemlingly peaceful and diplomatic, she unleashes an unmatched ferocity in the defense of her people from any threats... or thieves.'
	      }
      ]
    }
  }

  componentDidMount(){
  	const el = ReactDOM.findDOMNode(this)
    const container = el.querySelector('.parallax-container')
    var parallax = new window.Parallax(container)
    this.setState({scene: parallax})

    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  handleResize() {
  	let width = window.innerWidth, height = window.innerHeight
  	if(width > 768 && height < 650){
  		console.log('set to top')
  		this.setState({topAlign: true})
  	} else if(this.state.topAlign){
  		console.log('set to bottom')
  		this.setState({topAlign: false})
  	}
  }


  componentWillEnter (callback) {
    // console.log('character container component will enter')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 0
    }).to(el, 0.8, {
      opacity: 1
    })
  }

  componentDidEnter () {
    // console.log('character container component entered')
  }

  componentWillLeave (callback) {
    // console.log('character container component will leave')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 1,
    }).to(el, 0.8, {
      opacity: 0,
    })
  }

  componentDidLeave () {
    // console.log('character container component left')
    let parallax = this.state.scene
    parallax.disable();
    parallax = parallax.layers = parallax.element = undefined;

    window.removeEventListener('resize', this.handleResize)
  }

  handleNext() {
    let index = this.state.characterIndex + 1 < this.state.characters.length ? this.state.characterIndex + 1 : 0
    this.gotoCharacter(index)
  }

  handlePrev() {
    let index = this.state.characterIndex > 0 ? this.state.characterIndex - 1 : this.state.characters.length - 1
    this.gotoCharacter(index)
  }

  gotoCharacter(index){
  	this.setState({characterIndex: index})
  }

  showTickets() {
    this.setState({showTickets: true})
  }

  renderCharacters() {
  	return this.state.characters.map((character, i) => {
  		if(i === this.state.characterIndex){
  			return (
  				<Character content={character} key={i}/>
				)
  		} else {
        return null
      }
  	})
  }

  render() {
  	let character = this.renderCharacters()
  	let classes = classNames({
  		'bio-container': true,
  		'top-aligned': this.state.topAlign
  	})
    let ticketClasses = classNames({
      'get-tickets': true,
      'show-tickets': this.state.showTickets
    })
    return (
      <div className='characters'>
      	<div className="parallax-container">
	      	<div className="layer layer-container" data-depth="0.04"><div className={classes}>
	      		<ReactTransitionGroup component="div" className="character-container">
		      		{character}
		      	</ReactTransitionGroup>
		      	<div className="tapedeck"></div>

            <div className={ticketClasses} onClick={this.showTickets}>
              <a href="http://www.fandango.com/guardiansofthegalaxyvol.2_190573/movietimes" target="_blank"><div className="ticket-click"></div></a>
              <a href="http://www.movietickets.com/movie/mid/191861/n/Guardians-of-the-Galaxy-Vol-2#.WNF9ihLyu9Z" target="_blank"><div className="ticket-click"></div></a>
            </div>

	      	</div></div>
	      	<div className="layer layer-container" data-depth="0.006"><div className="tt-logo"></div></div>
	      	<div className="layer layer-container" data-depth="0.018"><div className="arrow-container">
	      		<div className="arrow prev" onClick={this.handlePrev.bind(this)}></div>
	      		<div className="arrow next" onClick={this.handleNext.bind(this)}></div>
	      	</div></div>
	      	<div className="layer layer-container" data-depth="0.018"><div className="character-close-button" onClick={this.props.closeCharacters}></div></div>
      	</div>
      </div>
    );
  }
}

export default CharactersContainer;


// WEBPACK FOOTER //
// ./src/Components/charactersContainer.js